var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoAwesome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3921_1120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 7.49992L16.8749 5.20825L19.1666 4.16659L16.8749 3.12492L15.8333 0.833252L14.7916 3.12492L12.4999 4.16659L14.7916 5.20825L15.8333 7.49992ZM9.58325 7.91659L7.49992 3.33325L5.41659 7.91659L0.833252 9.99992L5.41659 12.0833L7.49992 16.6666L9.58325 12.0833L14.1666 9.99992L9.58325 7.91659ZM15.8333 12.4999L14.7916 14.7916L12.4999 15.8333L14.7916 16.8749L15.8333 19.1666L16.8749 16.8749L19.1666 15.8333L16.8749 14.7916L15.8333 12.4999Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3921_1120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoAwesome);
export default __webpack_public_path__ + "static/media/auto_awesome.9e61e18c3bb960b439d67d10aedcd3c1.svg";
export { ForwardRef as ReactComponent };